import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // CRA-style
});

export default api;
